export function isEmptyObj(obj: any) {
    const hasOwnProperty = Object.prototype.hasOwnProperty;
    if (obj === null || obj === undefined) { return true; }
    if (obj.length > 0) { return false; }
    if (obj.length === 0) { return true; }
    for (const key in obj) {
        if (hasOwnProperty.call(obj, key)) { return false; }
    }
}

export function getTempAvatar() {
    return '../assets/images/foto-perfil.png';
}

export function firstFileToBase64(fileImage: File): Promise<any> {
    return new Promise((resolve, reject) => {
        const fileReader: FileReader = new FileReader();
        if (fileReader && fileImage != null) {
            fileReader.readAsDataURL(fileImage);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        } else {
            reject(new Error('Arquivo não encontrado'));
        }
    });
}